import { Injectable, Inject } from '@angular/core';
import { ReservationStatus } from '../model/reservation-status.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { InstructorStatus } from '../model/instructor-status.model';
import { LessonType } from '../model/lesson-type.model';
import { SportType } from '../model/sport-type.model';
import { SkillLevel } from '../model/skill-level.model';
import { Pricelist } from '../model/pricelist';
import { Grouptype } from '../model/grouptype';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getReservationStatuses(): Observable <ReservationStatus[]> {
    return this.httpClient.get<ReservationStatus[]>(this.baseUrl + '/api/Data/GetReservationStatuses');
  }

  getinstructorStatus(): Observable <InstructorStatus[]> {
    return this.httpClient.get<InstructorStatus[]>(this.baseUrl + '/api/Data/getinstructorStatus');
  }

  getlessonTypes(): Observable <LessonType[]> {
    return this.httpClient.get<LessonType[]>(this.baseUrl + '/api/Data/getlessonTypes');
  }

  getSportTypes(): Observable <SportType[]> {
    return this.httpClient.get<SportType[]>(this.baseUrl + '/api/Data/getSportTypes');
  }

  getSkillLevels(): Observable <SkillLevel[]> {
    return this.httpClient.get<SkillLevel[]>(this.baseUrl + '/api/Data/getSkillLevels');
  }

  getPriceList(lang: string): Observable <Pricelist[]> {
    return this.httpClient.get<Pricelist[]>(this.baseUrl + '/api/Data/getPriceList/' + lang);
  }

  getPriceListGearByGroupType(groupType): Observable <Pricelist[]> {
    let params = new HttpParams();
    params = params.append('groupType', groupType);
    return this.httpClient.get<Pricelist[]>(this.baseUrl + '/api/Data/getPriceListGearByGroupType', {params});
  }

  getGroupTypes(): Observable <Grouptype[]> {
    return this.httpClient.get<Grouptype[]>(this.baseUrl + '/api/Data/getGroupTypes');
  }

  getEquipmentTypesByGroupType(groupType?): Observable <Pricelist[]> {
    let params = new HttpParams();
    params = params.append('groupType', groupType);
    return this.httpClient.get<Pricelist[]>(this.baseUrl + '/api/Data/getEquipmentTypesByGroupType', {params});
  }




}
